import { Switch } from '@/components/ui/switch';
import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const I18N_PREFIX = 'integrations.googleDrive.sharing.invite';

interface DriveDomainShareToggleProps {
  domain: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const DriveDomainShareToggle = ({ domain, checked, onChange }: DriveDomainShareToggleProps) => {
  const { t } = useTranslation();

  return (
    <Box borderWidth="1px" borderColor="gray.100" rounded="lg" p={4} bg="bg.subtle">
      <Flex align="flex-start" justify="space-between" gap={4}>
        <Stack gap={1} flex="1">
          <Text fontSize="sm" fontWeight="medium">
            {t(`${I18N_PREFIX}.domainToggleLabel`, { domain })}
          </Text>
          <Text fontSize="xs" color="gray.fg">
            {t(`${I18N_PREFIX}.domainToggleHint`)}
          </Text>
        </Stack>
        <Switch checked={checked} onCheckedChange={({ checked: c }) => onChange(!!c)} />
      </Flex>
    </Box>
  );
};

export default DriveDomainShareToggle;
